import { render, staticRenderFns } from "./ngcBoolean.vue?vue&type=template&id=649c1d7e&scoped=true&"
import script from "./ngcBoolean.vue?vue&type=script&lang=js&"
export * from "./ngcBoolean.vue?vue&type=script&lang=js&"
import style0 from "./ngcBoolean.vue?vue&type=style&index=0&id=649c1d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c1d7e",
  null
  
)

export default component.exports